module.exports = __webpack_public_path__ + "img/money-icon-white.f94dc066.svg";